const shoelaceColors = [
	{ name: 'Text Color', color: '#000' },

	{ name: 'Primary Color', color: '#0284c7' },
	{ name: 'Primary Color Accent', color: '#0ea5e9' },

	{ name: 'Success Color', color: '#16a34a' },
	{ name: 'Success Color Accent', color: '#22c55e' },

	{ name: 'Neutral Color', color: '#52525b' },
	{ name: 'Neutral Color Accent', color: '#71717a' },

	{ name: 'Warning Color', color: '#d97706' },
	{ name: 'Warning Color Accent', color: '#f59e0b' },

	{ name: 'Danger Color', color: '#dc2626' },
	{ name: 'Danger Color Accent', color: '#ef437f' },

	{ name: 'White', color: '#fff' },
];

const themeColors = alertsDlxBlock.colorPalette;
shoelaceColors.push( ...themeColors );
export default shoelaceColors;
